import { includes } from 'lodash'

import { labels } from './labels'
import Address from '../assets/icons/feature-address.svg'
import General from '../assets/icons/feature-general.svg'
import Amenities from '../assets/icons/feature-amenities.svg'
import Dining from '../assets/icons/feature-dining.svg'
import AdditionalAmentities from '../assets/icons/feature-additional-amentities.svg'
import Parking from '../assets/icons/feature-parking.svg'
import Airport from '../assets/icons/feature-airport.svg'

export const featureTypes = {
  address: 'Address',
  general: 'General',
  amenities: 'Amenities',
  dining: 'Dining',
  additionalAmentities: 'AdditionalAmentities',
  parking: 'Parking',
  airport: 'Airport',
}

export const featureConfigs = [
  { type: featureTypes.address, title: labels.featureAddress, icon: Address },
  { type: featureTypes.general, title: labels.featureGeneral, icon: General },
  {
    type: featureTypes.amenities,
    title: labels.featureAmenities,
    icon: Amenities,
  },
  { type: featureTypes.dining, title: labels.featureDining, icon: Dining },
  {
    type: featureTypes.additionalAmentities,
    title: labels.featureAdditionalAmentities,
    icon: AdditionalAmentities,
  },
  { type: featureTypes.parking, title: labels.featureParking, icon: Parking },
  { type: featureTypes.airport, title: labels.featureAirport, icon: Airport },
]

const twoColsFeatures = [
  featureTypes.amenities,
  featureTypes.dining,
  featureTypes.additionalAmentities,
]

export function isTwoColsFeature(type) {
  return includes(twoColsFeatures, type)
}
